import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUniqueModelCodeAndSkus } from 'next-common';

interface FactoryEquipmentLevelsState {
  dataFromFactoryEquipLevels: IUniqueModelCodeAndSkus;
}

const initialState: FactoryEquipmentLevelsState = {
  dataFromFactoryEquipLevels: null,
};

const factoryEquipmentLevelsSlice = createSlice({
  name: 'factoryEquipmentLevels',
  initialState,
  reducers: {
    setDataFromFactoryEquipLevels: (state, action: PayloadAction<IUniqueModelCodeAndSkus>) => {
      state.dataFromFactoryEquipLevels = action.payload;
    },
  },
});

export const { setDataFromFactoryEquipLevels } = factoryEquipmentLevelsSlice.actions;
export default factoryEquipmentLevelsSlice.reducer;
